// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"553":"c56dae28","568":"d5644a95","927":"0f513323"}[chunkId] + ".chunk.css";
};